<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId">
        <el-cascader
          placeholder="公司名"
          ref="myCascader"
          :options="agentTree"
          :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
          :show-all-levels="false"
          clearable
          v-model="queryParams.userId"
          @change="search"
          filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item  prop="iccid">
        <el-input v-model="queryParams.iccid" placeholder="ICCID"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item  prop="imsi">
        <el-input v-model="queryParams.imsi" placeholder="IMSI"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item  prop="billDate">
        <el-input v-model="queryParams.billDate" placeholder="账单日期如20241101"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          value-format="yyyy-MM-dd"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="创建开始日期"
          end-placeholder="创建结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-download" v-hasPermi="['international:flow:export']" @click="exportFlow">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tabeData" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="companyName" label="公司名称" align="center" width="200px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center" width="200px">
        <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="info(scope.row)">{{ scope.row.iccid }}</el-link>
            <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                <i style="font-size:16px;margin-left:2px" class="el-icon-document-copy" @click="copy(scope.row.iccid)"></i>
            </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="imsi" label="IMSI" align="center" width="140px">
        <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="info(scope.row)">{{ scope.row.imsi }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="startTime" label="话单开始时间" align="center" width="160"></el-table-column>
      <el-table-column prop="endTime" label="话单结束时间" align="center" width="160"></el-table-column>
      <el-table-column prop="useFlow" label="用量" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="country" label="在用区域" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="operatorCode" label="运营商【国家】" align="center" width="220" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="billMonth" label="账单日期" align="center" width="160"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" width="160"></el-table-column>
    </el-table>
    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="initData"
      />
  </div>
</template>
<script>
import { internationalFlowRecords , internationalFlowExport} from "@/api/international.js"; //订单列表
import { agentTreeList } from "@/api/api.js"; //代理商
export default {
  name:'internationalFlow',
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  data() {
    return{
      // 代理商
      agentTree: [],
      dateRange:[],
      queryParams:{
        userId:undefined,
        iccid:undefined,
        imsi:undefined,
        billDate:undefined
      },
      total:0,
      page:1,
      pageSize:20,
      tabeData:[],
    }
  },
  methods: {
    //代理商列表
    agentTreeListMethod(){
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
    // 获取话单数据
    initData(){
      let params = {
        model:{
          ... this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      internationalFlowRecords(params).then(res =>{
        this.total = res.data.data.total;
        this.tabeData = res.data.data.records;
      })
    },
    search(){
      this.page = 1,
      this.initData();
    },
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },
    exportFlow(){
      let params = {
        ... this.addDateRange(this.queryParams, this.dateRange),
      };
      this.$alert("确定导出历史话单吗？", "历史话单导出", {
        confirmButtonText: "确定"
      }).then(() => {
        internationalFlowExport(params).then(res => {
          this.$notify({
              title: "成功",
              message: "历史话单导出成功，请在任务中心查看",
              type: "success",
              offset:30
            });
        });
      });
    },
    // 详情跳转
    info(row){
      this.$router.push({path:"/international/internationalDetail",query:{iccid: row.iccid}});
    },
    //复制数据
    copy(data) {
        let url = data;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
            message: '复制成功',
            type: 'success',
            duration:1000
        });
        oInput.remove()
    }
  },
  created() {
    this.agentTreeListMethod();
    this.initData()
  }
};
</script>



